module.exports = __webpack_public_path__ + "img/image-4A.4b8d2587.jpg";